import React, { useEffect, useState } from 'react'; 
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout and Common Imports
import Layout from './components/common/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services'; 
import Rates from './pages/Rates';           
import Contact from './pages/Contact';
import Partnership from './pages/Partnership';
import LoginForm from './pages/Login'; 
import RegisterForm from './pages/Register';

// User login
import UserDashboard from './components/user/UserDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import UserLayout from './components/user/UserLayout';
import UpcomingEvents from './components/user/UpcomingEvents';
import HappinessIndexTest from './components/user/HappinessIndexTest';
import UserProfile from './components/user/Userprofile';
import PaymentSelection from './components/user/PaymentSelection';
import MudrabhyasEnglish from './components/user/MudraAbhyasEnglish';
import HappinessMentor from './components/user/HappinessMentor';
import MissionClub from './components/user/MissionClub2022';
import DESIGN24STUDENT from './components/user/HA-DESIGN24STUDENT';
import DESIGN24WOMEN from './components/user/HA-DESIGN24WOMEN';
import DESIGN24MEN from './components/user/HA-DESIGN24MEN';
import MudrabhyasHindi from './components/user/MudrabhyasHindi';



// Admin Login
import AdminLayout from './components/admin/AdminLayout';
import AdminNavbar from './components/admin/AdminNavbar';
import AdminHome from './components/admin/AdminHome';
import AdminProfile from './components/admin/AdminProfile';

import RegisteredUsers from './components/admin/MembershipManagement/RegisteredUsers';
import NonResidenceUsers from './components/admin/MembershipManagement/NonResidenceusers';
import ReactivateUserCourse from './components/admin/MembershipManagement/ReactivateUserCourse';

import Courses from './components/admin/CourseDetails/Courses';
import AddvideoStudyMaterial from './components/admin/CourseDetails/AddvideosandStudyMaterial';

import TitleMaster from './components/admin/Masters/TitleMaster';
import QuestionMaster from './components/admin/Masters/QuestionMaster';
import ConclusionMaster from './components/admin/Masters/ConclusionMaster';
import MaterialType from './components/admin/Masters/MaterialType';


import EnquiryDetails from './components/admin/Others/Enquirydetails';
import BlogArticle from './components/admin/Others/BlogArticle';
import Addevent from './components/admin/Others/AddEvent';
import AddFeedbackVideos from './components/admin/Others/FeedbackVideos';
import AddFeedbackStatementDetails from './components/admin/Others/FeedbackStatement';


import RegistrationReport from './components/admin/Reports/RegistrationReport';
import TransactionReport from './components/admin/Reports/TransactionReport';
import CourseReport from './components/admin/Reports/CourseReport';
import UpcomingEventPaymentReport from './components/admin/Reports/UpcomingEventPaymentReport';
import EntryLogsReport from './components/admin/Reports/ScanEntryReport';


import AddUpcomingEvents from './components/admin/AddUpcomingEvent';

import QueryChat from './components/admin/QueryChat';

import AppointmentBooking from './components/admin/AppointmentBooking';

import WebContentManage from './components/admin/WebContentManage';

import ScanEntry from './components/admin/ScanEntry';




// --- Organization Pages Imports ---
import Intro from './pages/organization/Intro'; 
import Mission from './pages/organization/Mission';
import Founder from './pages/organization/Founder';
import PanelMembers from './pages/organization/PanelMembers';
import Awards from './pages/organization/NationalAwards';

// --- Courses pages ---
import MudraAbhyas from './pages/courses/MudraAbhyas';
import DesignStudent from './pages/courses/HappinessAmbassador/DesignStudent';
import DesignMen from './pages/courses/HappinessAmbassador/DesignMen';
import DesignWomen from './pages/courses/HappinessAmbassador/DesignWomen'; 

import MotivationalLecture from './pages/courses/MotivationalLecture';
import HappinessIndexCorporate from './pages/courses/HappinessIndexCorporate';
import SelfandPublicSpeaking from './pages/courses/SelfandPublicSpeaking';
import ShitSmart from './pages/courses/ShitSmart';
import HowtobeaCelebrityAuthor from './pages/courses/HowtobeaCelebrityAuthor';

// --- Publication pages ---
import BookRelease from './pages/publications/BookRelease';
import News from './pages/publications/News';

// --- Gallery ---
import DawadiCenter from './pages/gallery/DawadiCenter';
import Events from './pages/gallery/Events';
import Workshop from './pages/gallery/Workshop';

// --- Blog ---
import Article from './pages/blog/Article';

// --- Feedback ---
import Statements from './pages/feedback/Statements';
import Videos from './pages/feedback/Videos';

// Library and CSS
import AOS from 'aos';
import './css/aos.css';
import './css/animate.css';
import './css/main.css';

// Sansmruti Imports
import SansmrutiPublicationLayout from './components/common/SansmrutiPublicationLayout';
import SansmrutiHome from './pages/SansmrutiPublicationPages/SansmrutiHome';
import SansmrutiPackages from './pages/SansmrutiPublicationPages/SansmrutiPackages';
import SansmrutiContact from './pages/SansmrutiPublicationPages/SansmrutiContact';
import SansmrutiBookReleases from './pages/SansmrutiPublicationPages/SansmrutiBookReleases';
import SansmrutiIntroduction from './pages/SansmrutiPublicationPages/SansmrutiIntroduction';
import ForgotPassword from './pages/ForgotPassword';
import SetNewPassword from './pages/SetNewPassword';
import PaymentPage from './components/user/PaymentPage';




const CustomCloseButton = ({ closeToast }) => (
  <button 
    onClick={closeToast} 
    className="text-white bg-white/10 hover:bg-white/20 w-5 h-5 flex items-center justify-center rounded-full text-sm font-light border-none cursor-pointer ml-2 self-center transition-all"
  >
    &times;
  </button>
);

function App() {
  const [userRole, setUserRole] = useState(localStorage.getItem('role'));

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const handleStorageChange = () => {
      setUserRole(localStorage.getItem('role'));
    };

    window.addEventListener('storage', handleStorageChange);

    const handleScroll = () => {
      const navbar = document.getElementById("navbar");
      if (navbar) {
        if (window.scrollY > 80) { 
          navbar.classList.add("sticky"); 
        } else { 
          navbar.classList.remove("sticky"); 
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* ================= 1. MAIN WEBSITE (Layout) ================= */}
        <Route path="/TGSH" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="rates" element={<Rates />} />
          <Route path="contact" element={<Contact />} />
          <Route path="partnership" element={<Partnership />} />
          <Route path="login" element={<LoginForm />} />
          <Route path="register" element={<RegisterForm />} />
          <Route path="/TGSH/set-new-password/:uidb64/:token" element={<SetNewPassword />} />
          
          {/* Admin & User Basic Routes */}
          <Route 
            path="admin-dashboard" 
            element={userRole === "1" ? <div className="pt-24 text-center">Admin Dashboard</div> : <Navigate to="/TGSH/login" />} 
          />
          <Route 
            path="user-profile" 
            element={userRole === "2" ? <div className="pt-24 text-center text-2xl font-bold">User Profile Content</div> : <Navigate to="/TGSH/login" />} 
          />

          {/* Standard Content Routes */}
          <Route path="org/intro" element={<Intro />} />
          <Route path="org/mission" element={<Mission />} />
          <Route path="org/founder" element={<Founder />} />
          <Route path="org/panel" element={<PanelMembers />} />
          <Route path="org/awards" element={<Awards />} />

          <Route path="courses/mudra" element={<MudraAbhyas />} />
          <Route path="courses/happiness-ambassador/student" element={<DesignStudent />} />
          <Route path="courses/happiness-ambassador/men" element={<DesignMen />} />
          <Route path="courses/happiness-ambassador/women" element={<DesignWomen />} />
          <Route path="courses/MotivationalLecture" element={<MotivationalLecture />} />
          
          <Route path="courses/HappinessIndexCorporate" element={<HappinessIndexCorporate />} />
          <Route path="courses/SelfandPublicSpeaking" element={<SelfandPublicSpeaking />} />
          <Route path="courses/Shitsmart" element={<ShitSmart />} />
          <Route path="courses/HowtobeacelebrityAuthor" element={<HowtobeaCelebrityAuthor />} />

          <Route path="publication/BookRelease" element={<BookRelease/>} />
          <Route path="publication/News" element={<News/>} />
          
          <Route path="gallery/DawadiCenter" element={<DawadiCenter/>} />
          <Route path="gallery/Events" element={<Events/>} />
          <Route path="gallery/Workshop" element={<Workshop/>} />

          <Route path="blog/Article" element={<Article/>} />
          <Route path="feedback/Statements" element={<Statements />} />
          <Route path="feedback/Videos" element={<Videos />} />

          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password/:uidb64/:token" element={<SetNewPassword />} />
        </Route> {/* Layout Route Close */}

        {/* ================= 2. SANSMRUTI SECTION ================= */}
        <Route path="/TGSH/sansmruti" element={<SansmrutiPublicationLayout />}>
          <Route index element={<SansmrutiHome />} /> 
          <Route path="home" element={<SansmrutiHome />} />
          <Route path="introduction" element={<SansmrutiIntroduction />} /> 
          <Route path="book-releases" element={<SansmrutiBookReleases />} />
          <Route path="packages" element={<SansmrutiPackages />} />
          <Route path="contact" element={<SansmrutiContact />} />
        </Route> {/* Sansmruti Route Close */}

        {/* ================= 3. PROTECTED USER DASHBOARD ================= */}
        <Route path="/TGSH/user" element={<ProtectedRoute><UserLayout /></ProtectedRoute>}>
          <Route index element={<UserDashboard />} />
          <Route path="dashboard" element={<UserDashboard />} />
          <Route path="upcoming-events" element={<UpcomingEvents />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="paymentpage" element={<PaymentPage />} />
          <Route path="paymentselection" element={<PaymentSelection />} />
          <Route path="HappinessIndexTest" element={<HappinessIndexTest />} />
          <Route path="MudraAbhyasEnglish" element={<MudrabhyasEnglish />} />
          <Route path="HappinessMentor" element={<HappinessMentor />} />
          <Route path="MissionClub" element={<MissionClub />} />
          <Route path="DESIGN24STUDENT" element={<DESIGN24STUDENT />} />
          <Route path="MudrabhyasHindi" element={<MudrabhyasHindi />} />
          <Route path="DESIGN24WOMEN" element={<DESIGN24WOMEN />} />
          <Route path="DESIGN24MEN" element={<DESIGN24MEN />} />
        

        </Route>

        {/* ================== 4. PROTECTED ADMIN DASHBOARD ==================== */}
        <Route path="/TGSH/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<AdminHome />} />
          <Route path="Home" element={<AdminHome />} />
          <Route path="profile" element={<AdminProfile />} />
          
          {/* १. Membership Management Section */}
          <Route path="MembershipManagement" element={<div className="p-10 bg-white shadow rounded">MembershipManagement</div>} />
          <Route path="MembershipManagement/registered" element={<RegisteredUsers />} />
          <Route path="MembershipManagement/non-residence" element={<NonResidenceUsers />} />
          <Route path="MembershipManagement/reactivate" element={<ReactivateUserCourse />} />

          {/* २. Courses Details Section (Sidebar ) */}
          <Route path="CoursesDetails/courses" element={<Courses />} />
          <Route path="CoursesDetails/addvideoandstudymaterial" element={<AddvideoStudyMaterial />} />
          
          {/* --Master-- */}
          <Route path="Master/titlemaster" element={<TitleMaster />} />
          <Route path="Master/questionmaster" element={<QuestionMaster />} />
          <Route path="Master/conclusionmaster" element={<ConclusionMaster />} />
          <Route path="Master/materialtype" element={<MaterialType />} />

          {/* --Others-- */}
          <Route path="Others/enquirydetails" element={<EnquiryDetails />} />
          <Route path="Others/blogarticle" element={<BlogArticle />} />
          <Route path="Others/addevent" element={<Addevent />} />
          <Route path="Others/FeedbackVideos" element={<AddFeedbackVideos />} />
          <Route path="Others/FeedbackStatement" element={<AddFeedbackStatementDetails />} />

          {/* ---Reports--- */}
          <Route path="Reports/RegistrationReport" element={<RegistrationReport />} />
          <Route path="Reports/transactionreport" element={<TransactionReport />} />
          <Route path="Reports/Coursereport" element={<CourseReport />} />
          <Route path="Reports/UpcomingEventPaymentReport" element={<UpcomingEventPaymentReport />} />
          <Route path="Reports/ScanEntryReport" element={<EntryLogsReport />} />



          {/* ---UpcominEvent--- */}
          <Route path="AddUpcomingEvents" element={<AddUpcomingEvents />} />

          {/* ----Chats----- */}
          <Route path="Chat" element={<QueryChat />} />

          {/* ---Appointments-- */}
          <Route path="AppointmentBooking" element={<AppointmentBooking />} />

          {/* -----Add webcontent--- */}
          <Route path="WebContentManage" element={<WebContentManage />} />

          <Route path="ScanEntry" element={<ScanEntry />} />




        </Route>

        {/* Wildcard Route for 404/Unknown paths */}
        <Route path="/" element={<Navigate to="/TGSH/home" />} />
        <Route path="*" element={<Navigate to="/TGSH/home" />} />

      </Routes>
      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        theme="colored" 
        icon={false} // Disables the buggy default icon graphics
        closeButton={CustomCloseButton} // Uses our clean custom close button
      />
    </Router>
    
  );
}

export default App;